import React, { useEffect, useState } from "react";
import POSLeftHeader from "./POSLeftHeader";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import { apiKey } from "../../config/config";
import { toast } from "react-toastify";
import { FaPlus, FaMinus } from "react-icons/fa";
import { languageHelper, calculateCartOffers } from "../../config/helperFunctions";
import Select from "react-select";
import { FaTrash } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function POSOrderDetailTable({
  sidebarToggle,
  sidebarOpen,
  user,
  orderItemDetail,
  deliveryOrders,
  dineInOrders,
  takeawayOrders,
  holdOrders,
  pendingRiderPayments,
  confirmRiderPayment,
  allPaymentMethod,
  handleItemDelete,
  selectedOrderType,
  enabledOrderTypes,
  handleSelectOrderType,
  handleDiscountUpdate,
  handleDeliveryChargeUpdate,
  handleUpdateQuantity,
  handleAddModifier,
  selectedPaymentCompany,
  setSelectedPaymentCompany,
  customers,
  waiters,
  riders,
  cashiers,
  tables,
  selectedCustomerId,
  selectedCustomer,
  setSelectedCustomer,
  setAlert,
  handleCustomerSelect,
  totalItems,
  totalVat,
  subTotal,
  totalDiscount,
  discount,
  serviceDelivery,
  totalPayable,
  originalTotalPayable,
  selectedPaymentMethod,
  handleMultiplePaymentSubmit,
  handleSelectedPaymentMethod,
  handleDirectInvoice,
  isUpdate,
  createUpdateOrder,
  handleClearOrder,
  loyalty,
  handleLoyalty,
  loyaltyPoint,
  handleCardDiscountType,
  handleCardDiscountAmount,
  fetchOrders,
  updateTables,
  selectedCashier,
  setSelectedCashier,
  selectedRider,
  setSelectedRider,
  selectedWaiter,
  setSelectedWaiter,
  selectedTable,
  setSelectedTable,
  handleHoldOrder,
  showHoldButton,
  setSelectedOrder,
  setSelectedOrderType,
  setOrderItemDetail,
  setIsUpdate,
  fetchCustomers,
  setCustomers,
  setSelectedCustomerId,
  loading,
  currency,
  couponCode,
  setCouponCode,
  applyCoupon,
  giftCardCode,
  setGiftCardCode,
  verifiedGiftCard,
  setVerifiedGiftCard,
}) {
  const [openDelModal, setOpenDelModal] = useState(false);
  const [openCreditModal, setOpenCreditModal] = useState(false);
  const [openMultiCashModal, setOpenMultiCashModal] = useState(false);
  const [openGiftCardModal, setOpenGiftCardModal] = useState(false);
  const [giftCardInputCode, setGiftCardInputCode] = useState("");
  const [verifyingGiftCard, setVerifyingGiftCard] = useState(false);
  const [giftCardError, setGiftCardError] = useState("");

  const [multiCashGiftCardCode, setMultiCashGiftCardCode] = useState("");
  const [multiCashVerifiedGiftCard, setMultiCashVerifiedGiftCard] = useState(null);
  const [multiCashVerifyingGC, setMultiCashVerifyingGC] = useState(false);
  const [multiCashGCError, setMultiCashGCError] = useState("");
  const [openEmpCustomerModal, setOpenEmpCustomerModal] = useState(false);
  const [selectedEmpCard, setSelectedEmpCard] = useState(false);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);
  const [isModifierModalOpen, setIsModifierModalOpen] = useState(false);
  const [modifiers, setModifiers] = useState([]);
  const [selectedModifiers, setSelectedModifiers] = useState([]);
  const [selectedOrderModifier, setSelectedOrderModifier] = useState();
  const [menuNote, setMenuNote] = useState("");
  const [multiCashCheckedState, setMultiCashCheckedState] = useState({}); // Tracks which payment methods are checked
  const [paymentAmounts, setPaymentAmounts] = useState([]); // Tracks the amounts entered for each payment method
  const [totalPayment, setTotalPayment] = useState(0);
  const [showLoyaltyModal, setShowLoyaltyModal] = useState(false);
  const [redeemSAR, setRedeemSAR] = useState(0);
  const [redeemPoints, setRedeemPoints] = useState(loyaltyPoint);
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [customerFormData, setCustomerFormData] = useState({
    name: "",
    phone: "",
    email: "",
    customer_vat: "",
    date_of_birth: "",
    addresses: [],
    password: "12345678",
    password_confirmation: "12345678",
  });
  const [recentOrders, setRecentOrders] = useState([]);
  const [deal, setDeal] = useState([]);
  const [selectedDealVariations, setSelectedDealVariations] = useState({});

  // Reset gift card modal inputs when verifiedGiftCard or giftCardCode is cleared in POSMain
  useEffect(() => {
    if (!verifiedGiftCard && !giftCardCode) {
      setGiftCardInputCode("");
      setGiftCardError("");
    }
  }, [verifiedGiftCard, giftCardCode]);

  // Reset multi-cash & gift card inputs when cart is emptied after order placement
  useEffect(() => {
    if (orderItemDetail.length === 0) {
      setMultiCashCheckedState({});
      setPaymentAmounts([]);
      setMultiCashGiftCardCode("");
      setMultiCashVerifiedGiftCard(null);
      setMultiCashGCError("");
      setGiftCardInputCode("");
      setGiftCardError("");
    }
  }, [orderItemDetail.length]);

  const handleChange = (e) =>
    setCustomerFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  const handleAddressChange = (e) => {
    const { name, value } = e.target;

    setCustomerFormData((prev) => ({
      ...prev,
      addresses: prev.addresses?.length
        ? [
          { ...prev.addresses[0], [name]: value }, // update index 0
          ...prev.addresses.slice(1), // keep rest as-is
        ]
        : [
          { [name]: value }, // if addresses array was empty
        ],
    }));
  };

  useEffect(() => {
    setRedeemPoints(redeemSAR * loyalty?.convert_points || 0);
  }, [loyalty?.convert_points, redeemSAR]);

  const handleDeliveryChange = (id) => {
    handleClearOrder(true);
    setSelectedPaymentCompany(id);
    setOpenDelModal(false);
  };

  const handleCreditCardChange = (id) => {
    setSelectedPaymentCompany(id);
    setOpenCreditModal(false);
  };

  const handleCheckboxChange = (id) => {
    setMultiCashCheckedState((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleAmountChange = (id, amount) => {
    setPaymentAmounts((prevAmounts) => ({
      ...prevAmounts,
      [id]: amount,
    }));
  };

  const handleVerifyGiftCard = async (codeToVerify, isMultiPayment = false) => {
    if (!codeToVerify || !codeToVerify.trim()) {
      if (isMultiPayment) setMultiCashGCError(languageHelper("Please enter a gift card code"));
      else setGiftCardError(languageHelper("Please enter a gift card code"));
      return;
    }

    if (isMultiPayment) {
      setMultiCashVerifyingGC(true);
      setMultiCashGCError("");
    } else {
      setVerifyingGiftCard(true);
      setGiftCardError("");
    }

    try {
      const res = await axios.post(
        `${apiKey}/api/rms/admin/gift-cards/verify`,
        {
          code: codeToVerify.trim(),
          customer_id: selectedCustomerId || selectedCustomer?.id || 1,
          outlet_id: user?.user?.outlet_id,
          order_total: totalPayable,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (res.data?.success && res.data?.data) {
        const cardData = res.data.data;
        if (isMultiPayment) {
          setMultiCashVerifiedGiftCard(cardData);
          setMultiCashGiftCardCode(cardData.code);
          const giftCardEntry = multiCash?.multiple_payments?.find((p) => p.payment_method_id === 9);
          if (giftCardEntry) {
            const maxUsable = Math.min(Number(cardData.remaining_balance), Number(totalPayable || 0));
            setPaymentAmounts((prev) => ({
              ...prev,
              [giftCardEntry.id]: maxUsable,
            }));
          }
          toast.success(`${languageHelper("Gift card verified: Balance")} ${currency || "SAR"} ${cardData.remaining_balance}`);
        } else {
          setVerifiedGiftCard(cardData);
          setGiftCardCode(cardData.code);
          toast.success(`${languageHelper("Gift card verified: Balance")} ${currency || "SAR"} ${cardData.remaining_balance}`);
        }
      } else {
        const msg = res.data?.message || languageHelper("Failed to verify gift card");
        if (isMultiPayment) setMultiCashGCError(msg);
        else setGiftCardError(msg);
      }
    } catch (err) {
      const msg = err.response?.data?.message || languageHelper("Invalid or expired gift card");
      if (isMultiPayment) setMultiCashGCError(msg);
      else setGiftCardError(msg);
    } finally {
      if (isMultiPayment) setMultiCashVerifyingGC(false);
      else setVerifyingGiftCard(false);
    }
  };

  const handleSwitchToMultiPayments = () => {
    setOpenGiftCardModal(false);
    handleSelectedPaymentMethod(multiCash?.payment_method?.id);
    setSelectedPaymentCompany(null);

    const giftCardEntry = multiCash?.multiple_payments?.find((p) => p.payment_method_id === 9);
    const cashEntry = multiCash?.multiple_payments?.find((p) => p.payment_method_id === 1);
    const madaEntry = multiCash?.multiple_payments?.find((p) => p.payment_method_id === 2);
    const fallbackOther = cashEntry || madaEntry || multiCash?.multiple_payments?.find((p) => p.payment_method_id !== 9);

    const gcBal = Number(verifiedGiftCard?.remaining_balance || 0);
    const billTot = Number(totalPayable || 0);
    const rem = Math.max(0, billTot - gcBal);

    const newChecked = {};
    const newAmounts = {};

    if (giftCardEntry) {
      newChecked[giftCardEntry.id] = true;
      newAmounts[giftCardEntry.id] = Math.min(gcBal, billTot);
      setMultiCashVerifiedGiftCard(verifiedGiftCard);
      setMultiCashGiftCardCode(verifiedGiftCard.code);
    }

    if (fallbackOther && fallbackOther.id !== giftCardEntry?.id) {
      newChecked[fallbackOther.id] = true;
      newAmounts[fallbackOther.id] = rem;
    }

    setMultiCashCheckedState(newChecked);
    setPaymentAmounts(newAmounts);
    setOpenMultiCashModal(true);
  };

  const handleSubmit = () => {
    const giftCardEntry = multiCash?.multiple_payments?.find(
      (p) => p.payment_method_id === 9 && multiCashCheckedState[p.id]
    );

    if (giftCardEntry) {
      const activeGC = multiCashVerifiedGiftCard || verifiedGiftCard;
      if (!activeGC) {
        setAlert(languageHelper("Please verify the gift card code first."));
        return;
      }
      if (activeGC.customer_id && parseInt(selectedCustomerId || selectedCustomer?.id || 1) !== parseInt(activeGC.customer_id)) {
        setAlert(
          `${languageHelper("The gift card in multi-payments is only valid for")} ${activeGC.customer_name || languageHelper("the registered customer")}.`
        );
        return;
      }
      const gcAmount = Number(paymentAmounts[giftCardEntry.id] || 0);
      if (gcAmount > Number(activeGC.remaining_balance)) {
        setAlert(
          `${languageHelper("Gift card amount cannot exceed remaining balance:")} ${activeGC.remaining_balance}`
        );
        return;
      }
    }

    const selectedPayments = multiCash?.multiple_payments
      .filter((payment) => multiCashCheckedState[payment.id])
      .map((payment) => ({
        id: payment.id,
        amount: Number(paymentAmounts[payment.id] || 0),
        ...(payment.payment_method_id === 9
          ? {
              gift_card_code:
                multiCashGiftCardCode ||
                multiCashVerifiedGiftCard?.code ||
                verifiedGiftCard?.code ||
                giftCardCode,
            }
          : {}),
      }));
    handleMultiplePaymentSubmit(selectedPayments);
    setOpenMultiCashModal(false);
  };

  const handleModifierOpen = (index) => {
    setIsModifierModalOpen(true);
    setMenuNote(orderItemDetail[index].food_menu_note);
    setModifiers(orderItemDetail[index].food_menu_modifiers);
    setSelectedModifiers(orderItemDetail[index].food_menu_modifier_selected);
    setSelectedOrderModifier(index);
    const dealItems = orderItemDetail[index].is_deal === "yes" ? JSON.parse(orderItemDetail[index].deal_details) : [];
    setDeal(dealItems);

    if (orderItemDetail[index].is_deal === "yes" && orderItemDetail[index].food_menu_deal_variations) {
      const savedVariations = orderItemDetail[index].food_menu_deal_variations;

      // If it's an array (new format), transform it to the object map expected by UI
      if (Array.isArray(savedVariations)) {
        const mappedVariations = {};
        let arrayIndex = 0;

        dealItems.forEach((item, dIndex) => {
          if (item?.variants?.length > 0) {
            const qty = Number(item.qty);
            for (let idx = 0; idx < qty; idx++) {
              if (savedVariations[arrayIndex]) {
                mappedVariations[`${dIndex}-${idx}`] = savedVariations[arrayIndex].variation_id;
              }
              arrayIndex++;
            }
          } else {
            // For items without variants, we consume one entry from savedVariations
            arrayIndex++;
          }
        });
        setSelectedDealVariations(mappedVariations);
      } else {
        // Fallback for old format (if any) or existing object
        setSelectedDealVariations(savedVariations);
      }
    } else {
      setSelectedDealVariations({});
    }
  };

  const handleModifierClose = () => {
    setIsModifierModalOpen(false);
    setModifiers([]);
    setSelectedDealVariations({});
  };

  const handleModifierSelect = (e) => {
    const modifierId = e.target.value; // Get the modifier ID from value
    const modifierName = e.target.getAttribute("data-name"); // Get the name from data-name
    const modifierPrice = e.target.getAttribute("data-price"); // Get the price from data-price

    if (e.target.checked) {
      // Add modifier if checked
      setSelectedModifiers((prevModifiers) => [
        ...prevModifiers,
        {
          modifier_id: modifierId,
          modifier_name: modifierName,
          modifier_price: modifierPrice,
          quantity: 1,
        },
      ]);
    } else {
      // Remove modifier if unchecked
      setSelectedModifiers((prevModifiers) =>
        prevModifiers.filter((modifier) => modifier.modifier_id !== modifierId),
      );
    }
  };

  const handleDealVariationChange = (uniqueKey, variationId) => {
    setSelectedDealVariations((prev) => ({
      ...prev,
      [uniqueKey]: variationId,
    }));
  };

  const hanleLoyaltyOpen = () => {
    if (selectedCustomerId === 1) {
      setAlert(
        "Loyalty Point is not possible for Walk-in Customer, please choose another!",
      );
      return;
    }

    // selectedCustomer comes from the `customers` list fetched once on page
    // load (or re-fetched via updateCustomers() after a sale, whose own
    // fetch failure is only logged to the console, never surfaced to the
    // cashier -- see updateCustomers() in POSMain.jsx). Either way, by the
    // time someone clicks "Loyalty" it can be showing a stale points
    // balance (e.g. from before a prior sale credited new points this
    // session). Re-fetch this one customer directly here instead of
    // trusting that cached value, so the insufficient-points check and the
    // modal always reflect the real current balance.
    axios
      .get(`${apiKey}/api/rms/admin/customer/${selectedCustomerId}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        const freshCustomer = res.data;
        setSelectedCustomer(freshCustomer);
        if (freshCustomer.loyalty_points <= 0) {
          setAlert("Insufficiant Points!");
          return;
        }
        setShowLoyaltyModal(true);
      })
      .catch((err) => {
        console.log(err);
        // Fall back to whatever we already had rather than blocking the
        // cashier outright if this one lookup fails.
        if (selectedCustomer.loyalty_points <= 0) {
          setAlert("Insufficiant Points!");
          return;
        }
        setShowLoyaltyModal(true);
      });
  };
  
  const cash =
    allPaymentMethod && allPaymentMethod.filter((method) => method?.payment_method_id === 1)[0];
  const mada =
    allPaymentMethod && allPaymentMethod.filter((method) => method?.payment_method_id === 2)[0];
  const visa =
    allPaymentMethod && allPaymentMethod.filter((method) => method?.payment_method_id === 3)[0];
  const masterCard =
    allPaymentMethod && allPaymentMethod.filter((method) => method?.payment_method_id === 4)[0];
  let multiCash =
    allPaymentMethod && allPaymentMethod.filter((method) => method?.payment_method_id === 5)[0];
  const delivery =
    allPaymentMethod && allPaymentMethod.filter((method) => method?.payment_method_id === 6)[0];
  const creditCard =
    allPaymentMethod && allPaymentMethod.filter((method) => method?.payment_method_id === 7)[0];
  const employeeCard =
    allPaymentMethod && allPaymentMethod.filter((method) => method?.payment_method_id === 8)[0];
  const giftCard =
    allPaymentMethod && allPaymentMethod.filter((method) => method?.payment_method_id === 9)[0];

  // Multi Payments lets the cashier split a bill across the outlet's base
  // payment methods (Cash/Mada/Visa/MasterCard/Gift Card).
  if (multiCash) {
    multiCash = {
      ...multiCash,
      multiple_payments: [cash, mada, visa, masterCard, giftCard]
        .filter(Boolean)
        .map((method) => ({
          id: method.id,
          payment_method_id: method.payment_method_id,
          company_name: method.payment_method?.name,
        })),
    };
  }

  const handleCustomerAdd = (e) => {
    e.preventDefault();
    // return
    if (
      !selectedCustomer ||
      selectedCustomer.id === 1 ||
      !customerFormData.id
    ) {
      axios
        .post(`${apiKey}/api/rms/customer/register`, customerFormData)
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setCustomerFormData({
            name: "",
            phone: "",
            email: "",
            customer_vat: "",
            date_of_birth: "",
            addresses: [],
            password: "12345678",
            password_confirmation: "12345678",
          });
          setAddCustomerModal(false);

          Promise.all([fetchCustomers()])
            .then(([customerRes]) => {
              const mappedCustomers = customerRes.data.map((customer) => ({
                label: customer.name,
                value: customer.id,
                customer: customer,
              }));

              setCustomers(mappedCustomers);
              setTimeout(() => {
                setSelectedCustomerId(res.data.data.customer.id);
                setSelectedCustomer(res.data.data.customer);
              }, 100);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          toast.error("Error Occured", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    } else {
      axios
        .put(
          `${apiKey}/api/rms/admin/updateCustomer/${selectedCustomer.id}`,
          customerFormData,
          {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          },
        )
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setCustomerFormData({
            name: "",
            phone: "",
            email: "",
            customer_vat: "",
            date_of_birth: "",
            addresses: [],
            password: "12345678",
            password_confirmation: "12345678",
          });
          setAddCustomerModal(false);

          Promise.all([fetchCustomers()])
            .then(([customerRes]) => {
              const mappedCustomers = customerRes.data.map((customer) => ({
                label: customer.name,
                value: customer.id,
                customer: customer,
              }));

              setCustomers(mappedCustomers);
              setTimeout(() => {
                setSelectedCustomerId(res.data.data.id);
                setSelectedCustomer(res.data.data);
              }, 100);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          toast.error("Error Occured", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  const handleCustomer = (selectedOption, customerId) => {
    if (selectedOption.is_employee === 1) {
      axios
        .get(
          `${apiKey}/api/rms/customer/fetch_order_by_customer/${customerId}`,
          { params: { is_recent: true } },
        )
        .then((res) => {
          setRecentOrders(res.data);
          setSelectedCustomerId(customerId);
          setSelectedCustomer(selectedOption);
          setSelectedEmpCard(true);
          handleSelectedPaymentMethod(employeeCard.id);
          setTimeout(() => setOpenEmpCustomerModal(true), 100);
        })
        .catch((err) => console.log(err));
    } else {
      if (selectedPaymentMethod === employeeCard?.id) {
        setAlert("This is not a company employee!");
      } else {
        setSelectedCustomerId(customerId);
        setSelectedCustomer(selectedOption);
      }
    }

    if (verifiedGiftCard?.customer_id && parseInt(customerId) !== parseInt(verifiedGiftCard.customer_id)) {
      setVerifiedGiftCard(null);
      setGiftCardCode("");
      toast.info(
        `${languageHelper("Gift card removed: only valid for")} ${verifiedGiftCard.customer_name || languageHelper("registered customer")}`
      );
    }
    if (multiCashVerifiedGiftCard?.customer_id && parseInt(customerId) !== parseInt(multiCashVerifiedGiftCard.customer_id)) {
      setMultiCashVerifiedGiftCard(null);
      setMultiCashGiftCardCode("");
      const gcEntry = multiCash?.multiple_payments?.find((p) => p.payment_method_id === 9);
      if (gcEntry) {
        setPaymentAmounts((prev) => ({ ...prev, [gcEntry.id]: "" }));
      }
      toast.info(
        `${languageHelper("Gift card in multi-payments removed: only valid for")} ${multiCashVerifiedGiftCard.customer_name || languageHelper("registered customer")}`
      );
    }
  };

  useEffect(() => {
    let total = 0;
    const selectedPayments = multiCash?.multiple_payments?.filter((payment) => multiCashCheckedState[payment.id])
      .map((payment) => ({
        id: payment.id,
        amount: Number(paymentAmounts[payment.id] || 0),
      }));

    selectedPayments?.forEach((amount) => {
      total += amount.amount;
    });
    setTotalPayment(total);
  }, [multiCash?.multiple_payments, multiCashCheckedState, paymentAmounts]);

  const currentTableCustId = selectedCustomer?.id ?? selectedCustomerId;
  const cartOffers = calculateCartOffers(orderItemDetail, currentTableCustId);

  return (
    <>
      <section className="relative flex flex-col h-screen pl-2">
        <POSLeftHeader
          sidebarToggle={sidebarToggle}
          currency={currency}
          sidebarOpen={sidebarOpen}
          deliveryOrders={deliveryOrders}
          dineInOrders={dineInOrders}
          takeawayOrders={takeawayOrders}
          holdOrders={holdOrders}
          pendingRiderPayments={pendingRiderPayments}
          confirmRiderPayment={confirmRiderPayment}
          showHoldButton={showHoldButton}
          fetchOrders={fetchOrders}
          updateTables={updateTables}
          setSelectedOrder={setSelectedOrder}
          setSelectedOrderType={setSelectedOrderType}
          setOrderItemDetail={setOrderItemDetail}
          setIsUpdate={setIsUpdate}
        />
        <div className="bg-white mt-4 w-full p-2 rounded overflow-auto flex-1">
          <table className="w-full">
            <thead className="bg-[#f0f5f9] rounded-2xl">
              <tr>
                <th className="text-start px-1">{languageHelper("Item")}</th>
                <th className="text-start px-1">{languageHelper("Price")}</th>
                <th className="text-start px-1">{languageHelper("Qty")}</th>
                <th className="text-start px-1">
                  {languageHelper("Discount")}
                </th>
                <th className="text-start px-1">{languageHelper("Total")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="text-[#495057] text-xs">
              {orderItemDetail.map((item, index) => {

                const custId = currentTableCustId;
                const isDiscount =
                  item?.discount?.[0]?.specific_customers === "yes"
                    ? item?.discount?.[0]?.multi_customer_id?.some(
                        (id) => String(id) === String(custId)
                      )
                    : Boolean(item?.discount?.[0]?.discount_amount);

                // Buy N Get N Free offer calculation (single or pooled group)
                const lineOffer = cartOffers[index];
                const offer = lineOffer?.offer || item?.offers?.[0];
                const freeQty = lineOffer?.freeQty || 0;
                const lineOfferDiscount = lineOffer?.lineOfferDiscount || 0;

                return <>
                  <tr className="h-8" key={index}>
                    <td>
                      <div className="flex flex-col py-0.5">
                        <span className="flex gap-x-1 items-center">
                          <button onClick={() => handleModifierOpen(index)}>
                            <MdEdit size={14} />
                          </button>
                          {defaultLang === "text_en"
                            ? item.food_menu_name
                            : item.food_menu_name_ar}
                        </span>
                        {offer && (
                          <span
                            className={`text-[10px] w-fit px-1.5 py-0.5 rounded font-semibold mt-0.5 ${
                              freeQty > 0
                                ? "bg-green-100 text-green-700"
                                : "bg-purple-100 text-purple-700"
                            }`}
                          >
                            {freeQty > 0
                              ? `🎁 ${freeQty} ${languageHelper("Free applied!")}`
                              : (offer.offer_type === "group" || offer.offer_type === "category")
                              ? `🏷️ ${languageHelper("Mix")} ${offer.buy}+${offer.free} ${languageHelper("Free")}`
                              : `🎁 ${languageHelper("Buy")} ${offer.buy} ${languageHelper("Get")} ${offer.free} ${languageHelper("Free")}`}
                          </span>
                        )}
                      </div>
                    </td>
                    <td>
                      <span>{currency || "S.R"} {item.food_menu_original_unit_price}</span>
                    </td>
                    <td>
                      {item.is_weighted === 1 ? (
                        <QuantityInput
                          index={index}
                          item={item}
                          handleUpdateQuantity={handleUpdateQuantity}
                          handleItemDelete={handleItemDelete}
                        />
                      ) : (
                        <QuantityInputOld
                          index={index}
                          item={item}
                          handleUpdateQuantity={handleUpdateQuantity}
                          handleItemDelete={handleItemDelete}
                        />
                      )}
                    </td>
                    <td>
                      <div className="text-center border rounded">
                        {(
                          (isDiscount ? Number(item.food_menu_discount) || 0 : 0) +
                          lineOfferDiscount
                        ).toFixed(2)}
                      </div>
                    </td>
                    <td>
                      <span>
                        {currency || "S.R"}{" "}
                        {(
                          (isDiscount ? item.food_menu_after_discount : item.food_menu_original_unit_price) *
                            item.food_menu_qty -
                          lineOfferDiscount
                        ).toFixed(2)}
                      </span>
                    </td>
                    <td>
                      <button onClick={() => handleItemDelete(index)} className="cursor-pointer">
                        <FaTrash className="text-d-bg-text" size={14} />
                      </button>
                    </td>
                  </tr>
                  {item.is_deal === "yes" && (
                    <tr>
                      <td colSpan={5}>
                        {item.deal_details &&
                          JSON.parse(item.deal_details)?.map((deal, index) => (
                            <p key={index}>{`${deal.qty}x ${deal.name}`}</p>
                          ))}
                      </td>
                    </tr>
                  )}
                  {item.food_menu_modifier_selected?.map((modifier, index) => (
                    <tr key={index}>
                      <td>{modifier.modifier_name}</td>
                      <td>{currency || "S.R"} {modifier.modifier_price}</td>
                      <td></td>
                      <td></td>
                      <td>
                        {currency || "S.R"}{" "}
                        {(
                          modifier.modifier_price *
                          Math.ceil(item.food_menu_qty)
                        ).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                  {item.food_menu_note && (
                    <tr>
                      <td>{languageHelper("Note")}:</td>
                      <td colSpan={3}>{item.food_menu_note}</td>
                    </tr>
                  )}
                </>
              })}
            </tbody>
          </table>
        </div>
        <div className="bg-white p-2 relative bottom-0">
          <form className="flex flex-wrap gap-x-2 text-xs font-medium">
            {cash && (
              <label htmlFor="cash" className="flex items-center gap-x-0.5">
                <input
                  id="cash"
                  name="paymentMethod"
                  type="radio"
                  value={cash?.payment_method?.id}
                  checked={selectedPaymentMethod === cash?.payment_method?.id}
                  onChange={() => {
                    handleSelectedPaymentMethod(cash?.payment_method?.id);
                    setSelectedPaymentCompany(null);
                  }}
                />
                <span>{languageHelper(cash?.payment_method?.name)}</span>
              </label>
            )}
            {mada && (
              <label htmlFor="mada" className="flex items-center gap-x-0.5">
                <input
                  id="mada"
                  name="paymentMethod"
                  type="radio"
                  value={mada?.payment_method?.id}
                  checked={selectedPaymentMethod === mada?.payment_method?.id}
                  onChange={() => {
                    handleSelectedPaymentMethod(mada?.payment_method?.id);
                    setSelectedPaymentCompany(null);
                  }}
                />
                <span>{languageHelper(mada?.payment_method?.name)}</span>
              </label>
            )}
            {visa && (
              <label htmlFor="visa" className="flex items-center gap-x-0.5">
                <input
                  id="visa"
                  name="paymentMethod"
                  type="radio"
                  value={visa?.payment_method?.id}
                  checked={selectedPaymentMethod === visa?.payment_method?.id}
                  onChange={() => {
                    handleSelectedPaymentMethod(visa?.payment_method?.id);
                    setSelectedPaymentCompany(null);
                  }}
                />
                <span>{languageHelper(visa?.payment_method?.name)}</span>
              </label>
            )}
            {masterCard && (
              <label
                htmlFor="masterCard"
                className="flex items-center gap-x-0.5"
              >
                <input
                  id="masterCard"
                  name="paymentMethod"
                  type="radio"
                  value={masterCard?.payment_method?.id}
                  checked={selectedPaymentMethod === masterCard?.payment_method?.id}
                  onChange={() => {
                    handleSelectedPaymentMethod(masterCard?.payment_method?.id);
                    setSelectedPaymentCompany(null);
                  }}
                />
                <span>{languageHelper(masterCard?.payment_method?.name)}</span>
              </label>
            )}
            {multiCash && (
              <label
                htmlFor="multiCash"
                className="flex items-center gap-x-0.5"
              >
                <input
                  id="multiCash"
                  name="paymentMethod"
                  type="radio"
                  value={multiCash?.payment_method?.id}
                  checked={selectedPaymentMethod === multiCash?.payment_method?.id}
                  onClick={() => {
                    setOpenMultiCashModal(true);
                  }}
                  onChange={(e) => {
                    handleSelectedPaymentMethod(multiCash?.payment_method?.id);
                    setSelectedPaymentCompany(null);
                  }}
                />
                <span>{languageHelper(multiCash?.payment_method?.name)}</span>
              </label>
            )}
            {delivery && (
              <label htmlFor="delivery" className="flex items-center gap-x-0.5">
                <input
                  id="delivery"
                  name="paymentMethod"
                  type="radio"
                  value={delivery?.payment_method?.id}
                  checked={openDelModal || selectedPaymentMethod === delivery?.payment_method?.id}
                  onChange={(e) => {
                    handleSelectedPaymentMethod(delivery?.payment_method?.id);
                    setOpenDelModal(e.target.checked);
                    setSelectedPaymentCompany(null);
                  }}
                />
                <span>{languageHelper(delivery?.payment_method?.name)}</span>
              </label>
            )}
            {creditCard && (
              <label
                htmlFor="creditCard"
                className="flex items-center gap-x-0.5"
              >
                <input
                  id="creditCard"
                  name="paymentMethod"
                  type="radio"
                  value={creditCard?.payment_method?.id}
                  checked={openCreditModal || selectedPaymentMethod === creditCard?.payment_method?.id}
                  onChange={(e) => {
                    handleSelectedPaymentMethod(creditCard?.payment_method?.id);
                    setOpenCreditModal(e.target.checked);
                  }}
                />
                <span>{languageHelper(creditCard?.payment_method?.name)}</span>
              </label>
            )}
            {employeeCard && (
              <label
                htmlFor="employeeCard"
                className="flex items-center gap-x-0.5"
              >
                <input
                  id="employeeCard"
                  name="paymentMethod"
                  type="radio"
                  value={employeeCard?.payment_method?.id}
                  checked={
                    openEmpCustomerModal ||
                    selectedEmpCard ||
                    selectedPaymentMethod === employeeCard?.payment_method?.id
                  }
                  onChange={(e) => {
                    if (selectedCustomer.is_employee !== 1) {
                      setAlert("This is not a company employee!");
                      return;
                    }
                    handleSelectedPaymentMethod(employeeCard?.payment_method?.id);
                    setOpenEmpCustomerModal(e.target.checked);
                  }}
                />
                <span>{languageHelper(employeeCard?.payment_method?.name)}</span>
              </label>
            )}
            {giftCard && (
              <label
                htmlFor="giftCard"
                className="flex items-center gap-x-0.5 cursor-pointer"
              >
                <input
                  id="giftCard"
                  name="paymentMethod"
                  type="radio"
                  value={giftCard?.payment_method?.id}
                  checked={
                    openGiftCardModal ||
                    selectedPaymentMethod === giftCard?.payment_method?.id
                  }
                  onChange={() => {
                    handleSelectedPaymentMethod(giftCard?.payment_method?.id);
                    setSelectedPaymentCompany(null);
                    setGiftCardInputCode(giftCardCode || "");
                    setOpenGiftCardModal(true);
                  }}
                />
                <span>{languageHelper(giftCard?.payment_method?.name || "Gift Card")}</span>
                {verifiedGiftCard && selectedPaymentMethod === 9 && (
                  <span className="text-[10px] font-bold text-green-700 bg-green-50 px-1 py-0.5 rounded border border-green-200 ml-1">
                    ✓ {verifiedGiftCard.code}
                  </span>
                )}
              </label>
            )}
          </form>
        </div>
        <div className="bg-white text-[#495057] text-xs font-medium overflow-x-auto">
          <table className="w-full">
            <tbody>
              <tr>
                <td className="border text-center py-1 px-4">
                  {languageHelper("Total Items")}: {totalItems || 0}
                </td>
                <td className="border text-center py-1 px-4">
                  {languageHelper("Sub Total")}
                </td>
                <td className="border text-center py-1 px-4">
                  {currency || "S.R"} {subTotal || 0}
                </td>
                <td className="border text-center py-1 px-4">
                  {languageHelper("Discount")}
                </td>
                <td className="border text-center py-1 px-4">
                  <input
                    className="w-16 text-center border"
                    placeholder="Amt or %"
                    type="text"
                    onChange={(e) => handleDiscountUpdate(e.target.value || 0)}
                    value={discount || ""}
                  />
                </td>
              </tr>
              <tr>
                <td className="border text-center py-1 px-4">
                  {languageHelper("VAT")}: {currency || "S.R"} {totalVat || 0}
                </td>
                <td className="border text-center py-1 px-4">
                  {languageHelper("Total Discount")}
                </td>
                <td className="border text-center py-1 px-4">
                  {currency || "S.R"} {totalDiscount || 0}
                </td>
                <td className="border text-center py-1 px-4">
                  {languageHelper("Service/Delivery Charges")}
                </td>
                <td className="border text-center py-1 px-4">
                  <input
                    className="w-16 text-center border"
                    type="text"
                    onChange={(e) =>
                      handleDeliveryChargeUpdate(parseFloat(e.target.value))
                    }
                    value={serviceDelivery || ""}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="text-white bg-d-bg flex flex=wrap items-center justify-between p-2">
          <div className="text-sm text-center w-full">
            {languageHelper("Total Payable")} :{" "}
            {originalTotalPayable && parseFloat(originalTotalPayable) !== parseFloat(totalPayable) ? (
              <span className="ml-4">
                <span className="line-through text-gray-400 mr-2">
                  {currency || "S.R"} {originalTotalPayable}
                </span>
                <span>
                  {currency || "S.R"} {totalPayable || 0}
                </span>
              </span>
            ) : (
              <span className="ml-4"> {currency || "S.R"} {totalPayable || 0} </span>
            )}
          </div>
          <div className="flex gap-2">
            {loyalty?.status === 1 && (
              <button
                onClick={hanleLoyaltyOpen}
                className="bg-white text-[#774b96] text-xs p-2 w-14"
              >
                {languageHelper("Loyalty")}
              </button>
            )}
            <select
              className="bg-white h-8 border bg-d-bg rounded-md text-black text-xs col-span-2"
              name=""
              id=""
              onChange={(e) => setSelectedCashier(e.target.value)}
            >
              <option value="en">{languageHelper("Cashier")}</option>
              {cashiers.map((cashier, index) => (
                <option
                  key={index}
                  value={cashier.value}
                  selected={cashier.value === selectedCashier}
                >
                  {cashier.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="py-1 space-y-2">
          <div className={`grid ${enabledOrderTypes.length === 1 ? 'grid-cols-1' : enabledOrderTypes.length === 2 ? 'grid-cols-2' : 'grid-cols-3'} gap-1 w-full`}>
            {enabledOrderTypes.map((ot) => {
              const otId = ot.ordertype_id;
              const isSelected = selectedOrderType === otId;
              return (
                <button
                  key={otId}
                  onClick={() => handleSelectOrderType(otId)}
                  className={`border border-d-bg h-8 rounded-md text-xs p-1 flex gap-x-1 items-center justify-center hover:shadow-lg transition-shadow ${
                    isSelected ? "bg-d-cat-btn text-white fill-white" : "bg-white"
                  }`}
                >
                  {otId === 1 && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="16"
                      width="16"
                      viewBox="0 0 512 512"
                      className={isSelected ? "fill-white" : "fill-current"}
                    >
                      <path d="M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z" />
                    </svg>
                  )}
                  {otId === 3 && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="16"
                      width="14"
                      viewBox="0 0 448 512"
                      className={isSelected ? "fill-white" : "fill-current"}
                    >
                      <path d="M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z" />
                    </svg>
                  )}
                  {otId === 2 && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="16"
                      width="20"
                      viewBox="0 0 640 512"
                      className={isSelected ? "fill-white" : "fill-current"}
                    >
                      <path d="M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
                    </svg>
                  )}
                  <span>{languageHelper(ot.ordertype?.name)}</span>
                </button>
              );
            })}
          </div>
          <div className="grid grid-cols-6 gap-1">
            {selectedOrderType === 1 && (
              <>
                <Select
                  options={tables.filter(
                    (table) =>
                      table.is_available || table.value === selectedTable,
                  )}
                  value={tables.find((t) => t.value === selectedTable) || null}
                  onChange={(selected) => setSelectedTable(selected.value)}
                  placeholder={languageHelper("Table")}
                  isSearchable
                  menuPlacement="top"
                  className="text-xs col-span-2"
                />

                <Select
                  options={waiters}
                  value={
                    waiters.find((w) => w.value === selectedWaiter) || null
                  }
                  onChange={(selected) => setSelectedWaiter(selected.value)}
                  placeholder={languageHelper("Waiter")}
                  isSearchable
                  menuPlacement="top"
                  className="text-xs col-span-2"
                />
              </>
            )}
            {selectedOrderType === 2 && (
              <>
                <Select
                  options={riders}
                  value={riders.find((r) => r.value === selectedRider)}
                  onChange={(selected) => setSelectedRider(selected.value)}
                  placeholder={languageHelper("Rider")}
                  isSearchable
                  menuPlacement="top"
                  className="text-xs col-span-2"
                />
              </>
            )}
            <div className="flex gap-1 w-full col-span-2">
              {/* <select
                className="bg-white h-8 border bg-d-bg rounded-md text-black text-xs col-span-2 w-full"
                // name=""
                id="select-customer"
                onChange={handleCustomer}
                value={selectedCustomerId}
              >
                {customers.map((customer, index) => (
                  <option
                    key={index}
                    value={customer.value}
                    data-customer={JSON.stringify(customer.customer)}
                  >
                    {customer.label}
                  </option>
                ))}
              </select> */}
              <Select
                options={customers}
                value={customers.find((c) => c.value === selectedCustomerId)}
                onChange={(selected) => {
                  setSelectedCustomerId(selected.value);
                  handleCustomer(selected.customer, selected.value);
                }}
                placeholder="Select customer..."
                isSearchable
                menuPlacement="top"
                className="text-xs flex-1 min-w-0"
              />

              <button
                onClick={() => {
                  if (selectedCustomer.id === 1 || !selectedCustomer) {
                    return;
                  }
                  setCustomerFormData(selectedCustomer);
                  setAddCustomerModal(true);
                }}
                className="block mx-auto"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  width="16"
                  viewBox="0 0 512 512"
                  className="fill-d-bg-text"
                >
                  <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
                </svg>
              </button>
              <button
                onClick={() => {
                  setCustomerFormData({
                    name: "",
                    phone: "",
                    email: "",
                    customer_vat: "",
                    date_of_birth: "",
                    addresses: [],
                    password: "12345678",
                    password_confirmation: "12345678",
                  });
                  setAddCustomerModal(true);
                }}
                className="bg-d-cat-btn rounded py-1 px-2 w-fit block mx-auto"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  width="14"
                  viewBox="0 0 448 512"
                  fill="white"
                >
                  <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
                </svg>
              </button>
            </div>

            {selectedCustomerId !== 1 && (
              <div className="flex gap-x-2 col-span-2">
                <input
                  className="border rounded-md text-black text-xs col-span-2 p-2"
                  placeholder="Coupon Code"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                />
                <button
                  onClick={applyCoupon}
                  className="bg-d-cat-btn text-white rounded py-1 px-2 w-fit block mx-auto"
                >
                  {languageHelper("Apply")}
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="py-1 grid grid-cols-2 items-center gap-x-1 gap-y-2">
          <button
            className="border border-d-bg bg-white rounded-md text-black text-xs fill-black p-1 flex gap-x-1 items-center justify-center h-8"
            onClick={() => handleClearOrder()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="16"
              width="12"
              viewBox="0 0 384 512"
            >
              <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
            <span>{languageHelper("Cancel")}</span>
          </button>
          {showHoldButton && (
            <button
              onClick={() => {
                handleHoldOrder();
              }}
              disabled={loading}
              className="border border-d-bg bg-white rounded-md text-black text-xs fill-black p-1 flex gap-x-1 items-center justify-center h-8"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                width="14"
                viewBox="0 0 448 512"
              >
                <path d="M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z" />
              </svg>
              <span>{languageHelper("Hold")}</span>
            </button>
          )}
          <button
            disabled={loading}
            onClick={() => {
              if (selectedPaymentMethod === 9) {
                if (!verifiedGiftCard) {
                  setAlert(languageHelper("Please enter and verify a valid gift card before creating invoice."));
                  setOpenGiftCardModal(true);
                  return;
                }
                if (verifiedGiftCard.customer_id && parseInt(selectedCustomerId || selectedCustomer?.id || 1) !== parseInt(verifiedGiftCard.customer_id)) {
                  setAlert(
                    `${languageHelper("This gift card is only valid for")} ${verifiedGiftCard.customer_name || languageHelper("the registered customer")}.`
                  );
                  return;
                }
                if (parseFloat(verifiedGiftCard.remaining_balance) < parseFloat(totalPayable)) {
                  setAlert(languageHelper("Gift card balance is less than total payable. Please use Multi Payments to split payment."));
                  handleSwitchToMultiPayments();
                  return;
                }
              }
              handleDirectInvoice(true);
              setSelectedEmpCard(false);
            }}
            className="border border-d-bg bg-white rounded-md text-black text-xs fill-black p-1 flex gap-x-1 items-center justify-center h-8"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="16"
              width="12"
              viewBox="0 0 384 512"
            >
              <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
            </svg>
            <span>{languageHelper("Direct Invoice")}</span>
          </button>
          {showHoldButton && (
            <button
              disabled={loading}
              onClick={() => {
                if (selectedPaymentMethod === 9) {
                  if (!verifiedGiftCard) {
                    setAlert(languageHelper("Please enter and verify a valid gift card before placing order."));
                    setOpenGiftCardModal(true);
                    return;
                  }
                  if (verifiedGiftCard.customer_id && parseInt(selectedCustomerId || selectedCustomer?.id || 1) !== parseInt(verifiedGiftCard.customer_id)) {
                    setAlert(
                      `${languageHelper("This gift card is only valid for")} ${verifiedGiftCard.customer_name || languageHelper("the registered customer")}.`
                    );
                    return;
                  }
                  if (parseFloat(verifiedGiftCard.remaining_balance) < parseFloat(totalPayable)) {
                    setAlert(languageHelper("Gift card balance is less than total payable. Please use Multi Payments to split payment."));
                    handleSwitchToMultiPayments();
                    return;
                  }
                }
                createUpdateOrder(isUpdate ? "update" : "create");
              }}
              className="border border-d-bg bg-white rounded-md text-black text-xs fill-black p-1 flex gap-x-1 items-center justify-center h-8"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                width="14"
                viewBox="0 0 448 512"
              >
                <path d="M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z" />
              </svg>
              <span>
                {isUpdate
                  ? languageHelper("Update Order")
                  : languageHelper("Place Order")}
              </span>
            </button>
          )}
        </div>
      </section>
      {isTableModalOpen && selectedOrderType === 1 && (
        <div
          className="h-screen w-full z-20 fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md grid place-items-center"
          onClick={() => setIsTableModalOpen(false)}
        >
          <div
            className="max-w-screen-xl w-full bg-white rounded-lg overflow-clip h-[90vh] text-sm flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-d-bg text-center text-white font-medium text-lg">
              <h1>{languageHelper("Delivery")}</h1>
            </div>
            <div className="text-center text-gray-900">
              <p>{languageHelper("Order Number")}: New</p>
            </div>
            <div className="flex-1 p-4 overflow-auto">
              <div className="flex flex-wrap gap-4 justify-between">
                <div>
                  <div className="text-center">
                    <h3 className="font-medium">{languageHelper("Table 1")}</h3>
                    <p>{languageHelper("Sit Capacity")}: 4</p>
                    <p>{languageHelper("Available")}: 4</p>
                  </div>
                  <div>
                    <img
                      src="/assets/items/tbl2.png"
                      className="mx-auto"
                      alt=""
                    />
                  </div>
                  <table>
                    <thead className="text-center bg-d-bg text-white divide-x">
                      <tr>
                        <th className="w-16">{languageHelper("Ord.")}</th>
                        <th className="w-16">{languageHelper("Time")}</th>
                        <th className="w-16">{languageHelper("Person")}</th>
                        <th className="w-16">{languageHelper("Del")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <input
                            type="text"
                            className="w-full border bg-d-bg rounded px-2"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="w-full border bg-d-bg rounded px-2"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="w-full border bg-d-bg rounded px-2"
                          />
                        </td>
                        <td>
                          <button className="w-full bg-d-cat-btn rounded text-white text-center">
                            {languageHelper("Del")}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="flex justify-end gap-4 p-4">
              <button className="px-4 py-1 text-white bg-d-cat-btn rounded-md">
                {languageHelper("Submit")}
              </button>
              <button className="px-4 py-1 text-white bg-d-cat-btn rounded-md">
                {languageHelper("Proceed Without Table")}
              </button>
              <button
                className="px-4 py-1 text-white bg-d-cat-btn rounded-md"
                onClick={() => setIsTableModalOpen(false)}
              >
                {languageHelper("Cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
      {openDelModal && (
        <div
          className="h-screen w-full z-20 fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md grid place-items-center"
          onClick={() => setOpenDelModal(false)}
        >
          <div
            className="bg-white rounded-lg max-w-sm w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative bg-d-bg w-full">
              <h1 className="text-center text-white text-lg font-medium">
                {languageHelper("Delivery Options")}
              </h1>
              <button
                className="p-2 absolute top-0 right-0"
                onClick={() => setOpenDelModal(false)}
              >
                <IoMdClose className="text-gray-100" />
              </button>
            </div>
            <div className="py-4 px-16 text-sm">
              <h2 className="font-medium">
                {languageHelper("Companies Name")}
              </h2>
              <form className="px-2">
                {delivery?.multiple_payments?.map((payment, index) => (
                  <label
                    key={index}
                    htmlFor={`delivery-${index}`}
                    className="flex items-center gap-x-0.5"
                  >
                    <input
                      type="radio"
                      id={`delivery-${index}`}
                      name="deliveryOption"
                      checked={selectedPaymentCompany === payment.id}
                      onChange={() => {
                        handleDeliveryChange(payment.id);
                      }}
                    />
                    <span>{payment.company_name}</span>
                  </label>
                ))}
              </form>
            </div>
          </div>
        </div>
      )}
      {openCreditModal && (
        <div
          className="h-screen w-full z-20 fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md grid place-items-center"
          onClick={() => setOpenCreditModal(false)}
        >
          <div
            className="bg-white rounded-lg max-w-sm w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative bg-d-bg w-full">
              <h1 className="text-center text-white text-lg font-medium">
                {languageHelper("Credit Card")}
              </h1>
              <button
                className="p-2 absolute top-0 right-0"
                onClick={() => setOpenCreditModal(false)}
              >
                <IoMdClose className="text-gray-100" />
              </button>
            </div>
            <div className="py-4 px-16 text-sm">
              <h2 className="font-medium">
                {languageHelper("Companies Name")}
              </h2>
              <form className="px-2 space-y-1">
                {creditCard?.multiple_payments.map((payment, index) => (
                  <>
                    {payment.del_status === 0 && (
                      <label
                        key={index}
                        htmlFor={`payment-${index}`}
                        className="flex items-center justify-between gap-x-2 w-full"
                      >
                        <div className="flex items-center gap-x-0.5">
                          <input
                            type="radio"
                            id={`payment-${index}`}
                            name="paymentMethod"
                            checked={payment.id === selectedPaymentCompany}
                            onChange={() => {
                              handleCreditCardChange(payment.id);
                              handleCardDiscountType(payment.dis_type);
                              handleCardDiscountAmount(payment.discount_amount);
                            }}
                          />
                          <span>{payment.company_name}</span>
                        </div>
                        {payment.photo && (
                          <img
                            key={index}
                            src={payment.photo}
                            className="w-[60px] h-[35px]"
                            alt=""
                          />
                        )}
                      </label>
                    )}
                  </>
                ))}
              </form>
            </div>
          </div>
        </div>
      )}
      {openMultiCashModal && (
        <div
          className="h-screen w-full z-20 fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md grid place-items-center"
          onClick={() => setOpenMultiCashModal(false)}
        >
          <div
            className="bg-white rounded-lg max-w-sm w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative bg-d-bg w-full">
              <h1 className="text-center text-white text-lg font-medium">
                {languageHelper("Multi Payments")}
              </h1>
              <button
                className="p-2 absolute top-0 right-0"
                onClick={() => setOpenMultiCashModal(false)}
              >
                <IoMdClose className="text-gray-100" />
              </button>
            </div>
            <form
              className="py-4 px-8 text-sm"
              onSubmit={(e) => {
                e.preventDefault();
                if (parseFloat(totalPayable) !== parseFloat(totalPayment))
                  return;
                handleSubmit();
              }}
            >
              <h2 className="font-medium">Payment Methods</h2>
              <div className="px-2 space-y-2">
                {multiCash?.multiple_payments?.map((method, index) => (
                  <div key={index} className="py-1 border-b border-gray-100 last:border-b-0">
                    <label
                      htmlFor={`payment-${index}`}
                      className="flex items-center justify-between cursor-pointer"
                    >
                      <div className="flex items-center gap-x-1.5">
                        <input
                          type="checkbox"
                          id={`payment-${index}`}
                          name="paymentMethod"
                          checked={multiCashCheckedState[method.id] || false}
                          onChange={() => {
                            handleCheckboxChange(method.id);
                          }}
                        />
                        <span className="font-medium text-xs">{method.company_name}</span>
                      </div>
                      {multiCashCheckedState[method.id] && method.payment_method_id !== 9 && (
                        <input
                          type="text"
                          className="rounded border bg-d-bg px-2 py-0.5 text-xs w-28 text-right"
                          placeholder="Amount"
                          value={paymentAmounts[method.id] || ""}
                          onChange={(e) =>
                            handleAmountChange(method.id, e.target.value)
                          }
                        />
                      )}
                    </label>

                    {multiCashCheckedState[method.id] && method.payment_method_id === 9 && (
                      <div className="mt-2 p-2.5 bg-purple-50 rounded-lg border border-purple-200 text-xs">
                        <div className="flex gap-1.5 items-center mb-1.5">
                          <input
                            type="text"
                            placeholder={languageHelper("Gift Card Code")}
                            value={multiCashGiftCardCode}
                            onChange={(e) => setMultiCashGiftCardCode(e.target.value.toUpperCase())}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleVerifyGiftCard(multiCashGiftCardCode, true);
                              }
                            }}
                            className="flex-1 border border-purple-300 rounded px-2 py-1 bg-white uppercase font-mono text-xs focus:outline-none focus:ring-1 focus:ring-purple-500"
                          />
                          <button
                            type="button"
                            disabled={multiCashVerifyingGC || !multiCashGiftCardCode.trim()}
                            onClick={() => handleVerifyGiftCard(multiCashGiftCardCode, true)}
                            className="bg-purple-700 hover:bg-purple-800 text-white px-2.5 py-1 rounded text-xs font-semibold disabled:opacity-50 transition"
                          >
                            {multiCashVerifyingGC ? languageHelper("Checking...") : languageHelper("Verify")}
                          </button>
                        </div>
                        {multiCashGCError && (
                          <p className="text-red-600 text-[11px] mb-1">{multiCashGCError}</p>
                        )}
                        {(multiCashVerifiedGiftCard || verifiedGiftCard) && (
                          <div className="text-[11px] text-green-800 bg-green-50 p-1.5 rounded border border-green-200 mb-1.5 flex justify-between items-center">
                            <span>
                              ✓ {(multiCashVerifiedGiftCard || verifiedGiftCard).code} | {languageHelper("Balance")}: {currency} {(multiCashVerifiedGiftCard || verifiedGiftCard).remaining_balance}
                            </span>
                            <button
                              type="button"
                              onClick={() => {
                                setMultiCashVerifiedGiftCard(null);
                                setMultiCashGiftCardCode("");
                                setPaymentAmounts((prev) => ({ ...prev, [method.id]: "" }));
                              }}
                              className="text-red-500 hover:underline text-[10px] ml-1 font-semibold"
                            >
                              {languageHelper("Clear")}
                            </button>
                          </div>
                        )}
                        <div className="flex items-center justify-between pt-1 border-t border-purple-200">
                          <span className="text-gray-700 font-medium text-[11px]">
                            {languageHelper("Card Pay Amount")}:
                          </span>
                          <input
                            type="number"
                            step="0.01"
                            className="w-28 rounded border border-purple-300 px-2 py-0.5 bg-white text-right font-medium text-xs focus:outline-none focus:ring-1 focus:ring-purple-500"
                            placeholder="0.00"
                            value={paymentAmounts[method.id] || ""}
                            onChange={(e) => {
                              const activeGC = multiCashVerifiedGiftCard || verifiedGiftCard;
                              const val = parseFloat(e.target.value) || 0;
                              if (activeGC && val > parseFloat(activeGC.remaining_balance)) {
                                toast.warning(`${languageHelper("Cannot exceed card balance:")} ${currency} ${activeGC.remaining_balance}`);
                                handleAmountChange(method.id, activeGC.remaining_balance);
                                return;
                              }
                              handleAmountChange(method.id, e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-2 mt-5">
                <span className="text-gray-700">
                  {languageHelper("Total Bill Amount")}
                </span>
                <span className="font-semibold">{totalPayable || 0}</span>
                <span className="text-gray-700">
                  {languageHelper("Total Items")}
                </span>
                <span className="font-semibold">{orderItemDetail.length}</span>
                <span className="text-gray-700">
                  {languageHelper("Total Pay Amount")}
                </span>
                <span className="font-semibold">{totalPayment}</span>
              </div>
              {parseFloat(totalPayable) !== parseFloat(totalPayment) && (
                <div>
                  <p className="text-red-600 text-xs mt-2">
                    {languageHelper(
                      "Amount can not be greater or less than the total amount",
                    )}
                  </p>
                </div>
              )}
              <div className="mt-4">
                <button className="text-white py-2 px-4 bg-d-cat-btn text-center rounded-lg block mx-auto">
                  {languageHelper("Submit")}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {openGiftCardModal && (
        <div
          className="h-screen w-full z-30 fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md grid place-items-center"
          onClick={() => setOpenGiftCardModal(false)}
        >
          <div
            className="bg-white rounded-xl max-w-md w-full overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative bg-gradient-to-r from-purple-700 to-indigo-800 text-white p-4">
              <h2 className="text-center font-bold text-base">
                {languageHelper("Gift Card Payment")}
              </h2>
              <button
                className="p-2 absolute top-2 right-2 text-white hover:text-gray-200"
                onClick={() => setOpenGiftCardModal(false)}
              >
                <IoMdClose className="text-xl" />
              </button>
            </div>

            <div className="p-5">
              <label className="block text-xs font-semibold text-gray-700 mb-1">
                {languageHelper("Enter or Scan Gift Card Code")}
              </label>
              <div className="flex gap-2 mb-3">
                <input
                  type="text"
                  autoFocus
                  className="flex-1 uppercase font-mono tracking-wider border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-600"
                  placeholder="GC-XXXX-XXXX"
                  value={giftCardInputCode}
                  onChange={(e) => {
                    setGiftCardInputCode(e.target.value.toUpperCase());
                    setGiftCardError("");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleVerifyGiftCard(giftCardInputCode, false);
                    }
                  }}
                />
                <button
                  type="button"
                  disabled={verifyingGiftCard || !giftCardInputCode.trim()}
                  onClick={() => handleVerifyGiftCard(giftCardInputCode, false)}
                  className="bg-purple-700 hover:bg-purple-800 text-white px-4 py-2 rounded-lg text-xs font-semibold disabled:opacity-50 transition"
                >
                  {verifyingGiftCard ? languageHelper("Checking...") : languageHelper("Verify")}
                </button>
              </div>

              {giftCardError && (
                <div className="bg-red-50 border border-red-200 text-red-700 text-xs rounded-lg p-2.5 mb-3">
                  {giftCardError}
                </div>
              )}

              {verifiedGiftCard && (
                <div className="bg-gradient-to-br from-purple-50 to-indigo-50 border border-purple-200 rounded-xl p-4 mb-4">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <span className="text-[10px] font-bold uppercase tracking-wider text-purple-700 bg-purple-100 px-2 py-0.5 rounded">
                        {verifiedGiftCard.title || "Gift Card"}
                      </span>
                      <p className="font-mono font-bold text-gray-900 mt-1">
                        {verifiedGiftCard.code}
                      </p>
                    </div>
                    <div className="text-right">
                      <span className="text-[10px] text-gray-500 block">{languageHelper("Remaining Balance")}</span>
                      <span className="text-lg font-extrabold text-purple-900">
                        {currency || "SAR"} {Number(verifiedGiftCard.remaining_balance).toFixed(2)}
                      </span>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-2 text-xs border-t border-purple-200 pt-2 mt-2 text-gray-600">
                    <div>
                      <span className="text-gray-400 block text-[10px]">{languageHelper("Original Value")}</span>
                      <span className="font-medium">{currency || "SAR"} {verifiedGiftCard.value}</span>
                    </div>
                    <div>
                      <span className="text-gray-400 block text-[10px]">{languageHelper("Expires On")}</span>
                      <span className="font-medium">{verifiedGiftCard.expiration_date}</span>
                    </div>
                    {verifiedGiftCard.customer_name && (
                      <div className="col-span-2">
                        <span className="text-gray-400 block text-[10px]">{languageHelper("Customer")}</span>
                        <span className="font-medium">{verifiedGiftCard.customer_name}</span>
                      </div>
                    )}
                  </div>

                  <div className="mt-3 pt-3 border-t border-purple-200">
                    {Number(verifiedGiftCard.remaining_balance) >= Number(totalPayable) ? (
                      <div className="bg-green-100 text-green-800 text-xs p-2.5 rounded-lg flex items-center gap-1.5 font-medium">
                        <span>✓</span>
                        <span>
                          {languageHelper("Sufficient balance to cover full order:")} {currency || "SAR"} {Number(totalPayable).toFixed(2)}
                        </span>
                      </div>
                    ) : (
                      <div className="bg-amber-50 border border-amber-200 text-amber-800 text-xs p-2.5 rounded-lg space-y-2">
                        <p className="font-medium">
                          ⚠ {languageHelper("Card balance")} ({currency || "SAR"} {verifiedGiftCard.remaining_balance}) {languageHelper("is less than total")} ({currency || "SAR"} {Number(totalPayable).toFixed(2)}).
                        </p>
                        <p className="text-[11px] text-amber-700">
                          {languageHelper("Remaining")} {currency || "SAR"} {(Number(totalPayable) - Number(verifiedGiftCard.remaining_balance)).toFixed(2)} {languageHelper("can be paid using another method via Multi Payments.")}
                        </p>
                        <button
                          type="button"
                          onClick={handleSwitchToMultiPayments}
                          className="w-full bg-amber-600 hover:bg-amber-700 text-white py-1.5 px-3 rounded-lg font-semibold text-xs shadow-sm transition"
                        >
                          {languageHelper("Split Bill with Multi Payments")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="flex gap-2 justify-end mt-4">
                <button
                  type="button"
                  onClick={() => setOpenGiftCardModal(false)}
                  className="px-4 py-2 text-xs border rounded-lg text-gray-700 hover:bg-gray-100 font-medium"
                >
                  {languageHelper("Cancel")}
                </button>
                {verifiedGiftCard && (
                  <button
                    type="button"
                    onClick={() => {
                      const activeCustId = selectedCustomerId || selectedCustomer?.id || 1;
                      if (verifiedGiftCard.customer_id && parseInt(activeCustId) !== parseInt(verifiedGiftCard.customer_id)) {
                        setGiftCardError(
                          `${languageHelper("This gift card is registered specifically to")} ${verifiedGiftCard.customer_name || languageHelper("another customer")}. ${languageHelper("Please select this customer before applying.")}`
                        );
                        return;
                      }
                      if (Number(verifiedGiftCard.remaining_balance) < Number(totalPayable)) {
                        handleSwitchToMultiPayments();
                        return;
                      }
                      setGiftCardCode(verifiedGiftCard.code);
                      setOpenGiftCardModal(false);
                    }}
                    className="px-5 py-2 text-xs bg-purple-700 hover:bg-purple-800 text-white rounded-lg font-bold shadow transition"
                  >
                    {languageHelper("Apply to Order")}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isModifierModalOpen && (
        <div
          className="h-screen w-full z-20 fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md grid place-items-center"
          onClick={() => handleModifierClose()}
        >
          <div
            className="bg-white rounded-lg max-w-md w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative bg-d-bg w-full">
              <h1 className="text-center text-white text-lg font-medium">
                {languageHelper("Add Ons")}
              </h1>
            </div>
            <div className="grid grid-cols-2 p-4">
              {(!modifiers || modifiers?.length <= 0) && (
                <div>{languageHelper("No Modifier for selected item.")}</div>
              )}
              {modifiers?.map((item, index) => (
                <div className="inline-flex items-center my-2" key={index}>
                  <label
                    className="relative flex items-center px-3 rounded-full cursor-pointer"
                    htmlFor={item.modifier.id}
                  >
                    <input
                      type="checkbox"
                      className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-d-bg checked:bg-d-bg checked:before:bg-d-bg hover:before:opacity-10"
                      id={"all"}
                      value={item.modifier.id} // Use modifier ID as the value
                      data-name={item.modifier.name} // Store name in data-name
                      data-price={item.modifier.price} // Store price in data-price
                      onChange={handleModifierSelect}
                      defaultChecked={selectedModifiers.some(
                        (mod) => parseInt(mod.modifier_id) === item.modifier.id,
                      )}
                    />
                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </label>
                  {item.modifier.name}
                </div>
              ))}
            </div>
            {
              deal.length > 0 && (
                <div className="p-4">
                  <h2 className="font-medium">{languageHelper("Deal Items")}</h2>
                  <table className="w-full">
                    <thead>
                      <tr>
                        <th className="text-start">{languageHelper("SN")}</th>
                        <th className="text-start">{languageHelper("Item")}</th>
                        <th className="text-end">{languageHelper("Variation")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deal.map((item, index) => (
                        item?.variants?.length > 0 ? Array.from({ length: Number(item.qty) }).map((_, idx) => {
                          const variations = item.variants
                          const variationOptions = variations.map((variation) => {
                            return {
                              value: variation.id,
                              label: variation.name,
                            }
                          })
                          return <tr key={`${index}-${idx}`}>
                            <td>{`${index + 1}.${idx + 1}`}</td>
                            <td>{item.name}</td>
                            <td><Select
                              className="w-full"
                              options={variationOptions}
                              value={variationOptions.find((option) => option.value === selectedDealVariations[`${index}-${idx}`])}
                              onChange={(selectedOption) => handleDealVariationChange(`${index}-${idx}`, selectedOption.value)}
                            /></td>
                          </tr>
                        }) : <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.name}</td>
                          <td className="text-end"></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            }
            <div className="p-4">
              <label htmlFor="note">{languageHelper("Note")}</label>
              <input
                type="text"
                id="note"
                value={menuNote}
                onChange={(e) => setMenuNote(e.target.value)}
                className="w-full border border-d-bg rounded p-1"
              />
              <div className="flex gap-2 justify-between mt-2">
                <button
                  className="bg-d-cat-btn p-1 rounded text-white"
                  onClick={() => {
                    handleModifierClose();
                    setSelectedModifiers([]);
                    setMenuNote("");
                    setSelectedDealVariations({});
                  }}
                >
                  {languageHelper("Cancel")}
                </button>
                <button
                  className="bg-d-cat-btn p-1 rounded text-white"
                  onClick={() => {
                    // Transform selectedDealVariations to array format
                    const dealVariationsArray = [];

                    deal.forEach((item, index) => {
                      if (item?.variants?.length > 0) {
                        const qty = Number(item.qty);
                        for (let idx = 0; idx < qty; idx++) {
                          const key = `${index}-${idx}`;
                          const variationId = selectedDealVariations[key] || null;
                          dealVariationsArray.push({
                            item_id: item.food_menu_id,
                            variation_id: variationId,
                            qty: 1
                          });
                        }
                      } else {
                        // No variants, add one entry with null variation_id
                        dealVariationsArray.push({
                          item_id: item.food_menu_id,
                          variation_id: null,
                          qty: item.qty
                        });
                      }
                    });

                    handleAddModifier(
                      selectedOrderModifier,
                      selectedModifiers,
                      menuNote,
                      dealVariationsArray
                    );
                    setSelectedModifiers([]);
                    setMenuNote("");
                    setSelectedDealVariations({});
                    handleModifierClose();
                  }}
                >
                  {languageHelper("Add To Cart")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showLoyaltyModal && (
        <div
          className="fixed z-10 top-0 left-0 w-full bg-black bg-opacity-50 min-h-screen grid place-items-center"
          onClick={() => setShowLoyaltyModal(false)}
        >
          <div
            className="max-w-xs w-full bg-white rounded-lg overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-d-bg w-full flex justify-between p-2 text-white font-bold">
              <h3>{languageHelper("Loyalty Points")}</h3>
              <button onClick={() => setShowLoyaltyModal(false)}>X</button>
            </div>
            <div className="p-4">
              <p className="text-center text-red-600 font-medium">
                {loyalty?.convert_points} {languageHelper("Points Equal To")}{" "}
                {loyalty.per_price} {currency || "S.R"}
              </p>
              <div className="space-y-1">
                <div className="flex justify-between font-medium text-sm">
                  <span>{languageHelper("Loyalty Points")}:</span>
                  <span>{selectedCustomer.loyalty_points}</span>
                </div>
                <div className="flex justify-between font-medium text-sm">
                  <span>{languageHelper(`To ${currency || "S.R"}`)}:</span>
                  <span>
                    {parseFloat(
                      selectedCustomer.loyalty_points / loyalty?.convert_points,
                    )}
                  </span>
                </div>
                <div className="flex justify-between font-medium text-sm">
                  <span>{languageHelper(`Redeem ${currency || "S.R"}`)}:</span>
                  <span>
                    <input
                      type="text"
                      className="border bg-d-bg rounded px-1"
                      placeholder="Enter redeem points"
                      value={redeemSAR}
                      onChange={(e) =>
                        setRedeemSAR(parseInt(e.target.value) || "")
                      }
                    />
                  </span>
                </div>
                <div className="flex justify-between font-medium text-sm">
                  <span>{languageHelper("Redeem Points")}:</span>
                  <span>{redeemPoints}</span>
                </div>
                <div className="flex justify-between font-medium text-sm">
                  <span>{languageHelper("Total bill amount")}:</span>
                  <span>{totalPayable}</span>
                </div>
                <div className="flex justify-between font-medium text-sm">
                  <span>{languageHelper("Remaining Points")}:</span>
                  <span>{selectedCustomer.loyalty_points - redeemPoints}</span>
                </div>
                <div className="flex justify-between font-medium text-sm">
                  <span>{languageHelper("Remaining Amount")}:</span>
                  <span>{totalPayable - redeemSAR}</span>
                </div>
                <div className="w-full">
                  <button
                    onClick={() => {
                      handleLoyalty(redeemPoints);
                      setShowLoyaltyModal(false);
                    }}
                    className="px-4 py-1 text-white bg-d-cat-btn rounded-md block mx-auto"
                  >
                    {languageHelper("Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {addCustomerModal && (
        <div
          className="fixed z-10 top-0 left-0 w-full bg-black bg-opacity-50 h-screen grid place-items-center overflow-y-scroll p-6"
          onClick={() => setAddCustomerModal(false)}
        >
          <div
            className="max-w-md w-full bg-white rounded-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-d-bg w-full flex justify-between p-2 text-white font-bold">
              <h3>{languageHelper("Add Customer")}</h3>
              <button onClick={() => setAddCustomerModal(false)}>X</button>
            </div>
            <form
              onSubmit={handleCustomerAdd}
              className="p-4 text-xs space-y-2"
            >
              <div className="flex flex-col">
                <label
                  htmlFor="name"
                  className="block mb-1 font-semibold relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 w-fit"
                >
                  {languageHelper("Name")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="name"
                  name="name"
                  value={customerFormData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="phone"
                  className="block font-semibold relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 w-fit"
                >
                  {languageHelper("Phone")}
                </label>
                <span className="mb-1 font-medium text-red-500">
                  {languageHelper("Should have country code")}
                </span>
                <PhoneInput
                  defaultCountry="sa"
                  className="border rounded w-full"
                  inputClassName="w-full"
                  placeholder="Enter your number"
                  name="phone"
                  value={customerFormData.phone}
                  onChange={(e) => setCustomerFormData({ ...customerFormData, phone: e })}
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="email"
                  className="block mb-1 font-semibold w-fit"
                >
                  {languageHelper("Email")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="email"
                  name="email"
                  value={customerFormData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="vatNo"
                  className="block mb-1 font-semibold relative w-fit"
                >
                  {languageHelper("Customer Vat No")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="vatNo"
                  name="customer_vat"
                  value={customerFormData.customer_vat}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="dob"
                  className="block mb-1 font-semibold relative w-fit"
                >
                  {languageHelper("DOB")}
                </label>
                <input
                  type="date"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="dob"
                  name="date_of_birth"
                  value={customerFormData.date_of_birth}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="delAdd"
                  className="block mb-1 font-semibold relative w-fit"
                >
                  {languageHelper("Street Number")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="delAdd"
                  name="address_line_1"
                  value={
                    customerFormData?.addresses?.length > 0
                      ? customerFormData?.addresses[0]?.address_line_1 || ""
                      : ""
                  }
                  onChange={handleAddressChange}
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="delAdd"
                  className="block mb-1 font-semibold relative w-fit"
                >
                  {languageHelper("Building Number")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="delAdd"
                  name="address_line_2"
                  value={
                    customerFormData?.addresses?.length > 0
                      ? customerFormData?.addresses[0]?.address_line_2 || ""
                      : ""
                  }
                  onChange={handleAddressChange}
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="delAdd"
                  className="block mb-1 font-semibold relative w-fit"
                >
                  {languageHelper("City Subdivision")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="delAdd"
                  name="state"
                  value={
                    customerFormData?.addresses?.length > 0
                      ? customerFormData?.addresses[0]?.state || ""
                      : ""
                  }
                  onChange={handleAddressChange}
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="delAdd"
                  className="block mb-1 font-semibold relative w-fit"
                >
                  {languageHelper("City")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="delAdd"
                  name="city"
                  value={
                    customerFormData?.addresses?.length > 0
                      ? customerFormData?.addresses[0]?.city || ""
                      : ""
                  }
                  onChange={handleAddressChange}
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="delAdd"
                  className="block mb-1 font-semibold relative w-fit"
                >
                  {languageHelper("Postal Code")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="delAdd"
                  name="postal_code"
                  value={
                    customerFormData?.addresses?.length > 0
                      ? customerFormData?.addresses[0]?.postal_code || ""
                      : ""
                  }
                  onChange={handleAddressChange}
                />
              </div>
              {/* <div className="flex flex-col">
                <label
                  htmlFor="delAdd"
                  className="block mb-1 font-semibold relative w-fit"
                >
                  {languageHelper("Delivery Address")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 w-full"
                  id="delAdd"
                  name="address"
                  value={customerFormData.address}
                  onChange={handleChange}
                />
              </div> */}
              <div>
                <p className="text-xs">
                  {languageHelper("By Default Password is")}{" "}
                  <strong>12345678</strong>
                </p>
              </div>
              <div className="flex justify-end gap-4 mt-4">
                <button
                  type="button"
                  onClick={() => setAddCustomerModal(false)}
                  className="text-white bg-d-cat-btn px-4 py-2 rounded-md"
                >
                  {languageHelper("Cancel")}
                </button>
                <button
                  type="submit"
                  className="text-white bg-d-cat-btn px-4 py-2 rounded-md"
                >
                  {languageHelper("Submit")}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {openEmpCustomerModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl p-6">
            <h2 className="text-2xl font-semibold text-center mb-6">
              {languageHelper("Employee Information")}
            </h2>

            <div className="flex items-center space-x-6 mb-6">
              <div className="flex-shrink-0">
                <img
                  src="https://via.placeholder.com/100"
                  alt="Employee"
                  className="w-24 h-24 rounded-full border"
                />
              </div>

              <div className="grid grid-cols-3 gap-1">
                <div>
                  <h4 className="font-semibold">
                    {languageHelper("Employee Name")}:
                  </h4>
                  <p>{selectedCustomer.name}</p>
                </div>
                <div>
                  <h4 className="font-semibold">{languageHelper("Phone")}:</h4>
                  <p>{selectedCustomer.phone}</p>
                </div>
                <div>
                  <h4 className="font-semibold">{languageHelper("Email")}:</h4>
                  <p className="break-words whitespace-normal">
                    {selectedCustomer.email}
                  </p>
                </div>
                <div>
                  <h4 className="font-semibold">
                    {languageHelper("Company Name")}:
                  </h4>
                  <p>{selectedCustomer.company_name}</p>
                </div>
                <div>
                  <h4 className="font-semibold">
                    {languageHelper("Employee Card No")}:
                  </h4>
                  <p>{selectedCustomer.employe_card_no}</p>
                </div>
                <div>
                  <h4 className="font-semibold">
                    {languageHelper("Date of Birth")}:
                  </h4>
                  <p>{selectedCustomer.date_of_birth}</p>
                </div>
                <div className="col-span-3">
                  <h4 className="font-semibold">
                    {languageHelper("Address")}:
                  </h4>
                  <p>{selectedCustomer.addresses[0]?.address_line_1}</p>
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2">
                {languageHelper("Order Details")}
              </h3>
              {recentOrders?.length > 0 ? (
                recentOrders.map((order, idx) => (
                  <ul key={idx} className="list-disc pl-6 text-sm">
                    <li>
                      <strong>
                        {languageHelper("Order")} #{order.token_no}:
                      </strong>{" "}
                      {
                        order.order_details[0]?.food_menu?.category
                          ?.category_name
                      }
                    </li>
                    <li>
                      <strong>{languageHelper("Category")}:</strong>{" "}
                      {
                        order.order_details[0]?.food_menu?.category
                          ?.category_name
                      }
                    </li>
                    <li>
                      <strong>{languageHelper("Quantity")}:</strong> 1
                    </li>
                  </ul>
                ))
              ) : (
                <p>{languageHelper("No recent orders found")}.</p>
              )}
            </div>

            <div className="mt-6 text-center">
              <button
                onClick={() => setOpenEmpCustomerModal(false)}
                className="bg-purple-700 hover:bg-purple-800 text-white px-6 py-2 rounded-md shadow"
              >
                {languageHelper("OK")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// function QuantityInput({
//   item,
//   handleUpdateQuantity,
//   handleItemDelete,
//   index,
// }) {
//   const [quantity, setQuantity] = useState(item.food_menu_qty);

//   const incrementQty = (idx, currentQty) => {
//     const newQty = currentQty + 1;
//     setQuantity(newQty);
//     handleUpdateQuantity(idx, newQty);
//   };

//   const decrementQty = (idx, currentQty) => {
//     const newQty = Math.max(0, currentQty - 1);
//     setQuantity(newQty);
//     handleUpdateQuantity(idx, newQty);
//     if (newQty <= 0) handleItemDelete(idx);
//   };

//   return (
//     <span className="flex gap-x-1">
//       <button
//         className="bg-d-bg p-1 rounded"
//         onClick={() => decrementQty(index, quantity)}
//       >
//         <FaMinus className="text-white" />
//       </button>
//       <input
//         className="w-8 border rounded text-center"
//         type="text"
//         value={quantity}
//         onChange={(e) => {
//           const newQty = parseFloat(e.target.value || 0);
//           setQuantity(newQty);
//           handleUpdateQuantity(index, newQty);
//         }}
//         onBlur={() => {
//           if (quantity <= 0) handleItemDelete(index);
//         }}
//       />
//       <button
//         className="bg-d-bg p-1 rounded"
//         onClick={() => incrementQty(index, quantity)}
//       >
//         <FaPlus className="text-white" />
//       </button>
//     </span>
//   );
// }

function QuantityInput({
  item,
  handleUpdateQuantity,
  handleItemDelete,
  index,
}) {
  const [inputValue, setInputValue] = useState(item.food_menu_qty.toString());

  const incrementQty = () => {
    const currentQty = parseFloat(inputValue) || 0;
    const newQty = currentQty + 1;
    setInputValue(newQty.toString());
    handleUpdateQuantity(index, newQty);
  };

  const decrementQty = () => {
    const currentQty = parseFloat(inputValue) || 0;
    const newQty = Math.max(0, currentQty - 1);
    setInputValue(newQty.toString());
    handleUpdateQuantity(index, newQty);
    if (newQty <= 0) handleItemDelete(index);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    // Allow any decimal input during typing
    if (value === "" || /^\d*\.?\d{0,3}$/.test(value)) {
      setInputValue(value);

      // Only update parent if it's a complete number (not "0.")
      const numValue = parseFloat(value);
      if (!isNaN(numValue) && !value.endsWith(".")) {
        handleUpdateQuantity(index, numValue);
      }
    }
  };

  const handleBlur = () => {
    const numValue = parseFloat(inputValue);

    // If invalid, empty, or 0, delete the item
    if (isNaN(numValue) || inputValue === "" || numValue <= 0) {
      handleItemDelete(index);
    } else {
      // For valid numbers, clean up the display
      setInputValue(numValue.toString());
      handleUpdateQuantity(index, numValue);
    }
  };

  return (
    <span className="flex gap-x-1">
      <button className="bg-d-bg p-1 rounded" onClick={decrementQty}>
        <FaMinus className="text-white" />
      </button>
      <input
        className="w-16 border rounded text-center"
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        inputMode="decimal"
        placeholder="0"
      />
      <button className="bg-d-bg p-1 rounded" onClick={incrementQty}>
        <FaPlus className="text-white" />
      </button>
    </span>
  );
}

function QuantityInputOld({
  item,
  handleUpdateQuantity,
  handleItemDelete,
  index,
}) {
  const [quantity, setQuantity] = useState(item.food_menu_qty);

  const incrementQty = (idx, currentQty) => {
    const newQty = currentQty + 1;
    setQuantity(newQty);
    handleUpdateQuantity(idx, newQty);
  };

  const decrementQty = (idx, currentQty) => {
    const newQty = Math.max(0, currentQty - 1);
    setQuantity(newQty);
    handleUpdateQuantity(idx, newQty);
    if (newQty <= 0) handleItemDelete(idx);
  };

  const handleBlur = () => {
    const numValue = parseFloat(quantity);

    // If invalid, empty, or 0, delete the item
    if (isNaN(numValue) || quantity === "" || numValue <= 0) {
      handleItemDelete(index);
    } else {
      // For valid numbers, clean up the display
      setQuantity(numValue.toString());
      handleUpdateQuantity(index, numValue);
    }
  };

  return (
    <span className="flex gap-x-1">
      <button
        className="bg-d-bg p-1 rounded"
        onClick={() => decrementQty(index, quantity)}
      >
        <FaMinus className="text-white" />
      </button>
      <input
        className="w-16 border rounded text-center"
        type="text"
        value={quantity}
        onChange={(e) => {
          const newQty = parseInt(e.target.value || 0);
          setQuantity(newQty);
          handleUpdateQuantity(index, newQty);
        }}
        onBlur={handleBlur}
      />
      <button
        className="bg-d-bg p-1 rounded"
        onClick={() => incrementQty(index, quantity)}
      >
        <FaPlus className="text-white" />
      </button>
    </span>
  );
}

export default POSOrderDetailTable;
